module.exports = __webpack_public_path__ + "static/img/left_pre.b75060a1.png";